/**
 * ClickableArtistName - A chip that opens ArtistLightbox when clicked
 *
 * Separated from ArtistLightbox to avoid circular imports with ArtistCard.
 */

import { useState, useCallback, lazy, Suspense } from 'react';
import { createPortal } from 'react-dom';
import './ArtistLightbox.css';

// Lazy load ArtistLightbox to avoid circular import
const ArtistLightbox = lazy(() => import('./ArtistLightbox'));

interface ClickableArtistNameProps {
  name: string;
  className?: string;
  children?: React.ReactNode;
}

export function ClickableArtistName({ name, className = '', children }: ClickableArtistNameProps) {
  const [showLightbox, setShowLightbox] = useState(false);

  const handleClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowLightbox(true);
  }, []);

  if (!name) {
    return null;
  }

  return (
    <>
      <button
        className={`clickable-artist-name ${className}`}
        onClick={handleClick}
        title={`View ${name}`}
      >
        {children || name}
      </button>
      {showLightbox && createPortal(
        <Suspense fallback={<div className="artist-lightbox-overlay"><div className="lightbox-loading"><div className="loading-spinner" /></div></div>}>
          <ArtistLightbox
            artistName={name}
            onClose={() => setShowLightbox(false)}
          />
        </Suspense>,
        document.body
      )}
    </>
  );
}
